import React from 'react';
import { Link } from 'react-router-dom';
import { FaDiscord } from 'react-icons/fa';
import { CornerDecoration } from '@components/common';
import './HomePage.css';

const DISCORD_INVITE_URL = 'https://discord.com/invite/GCeMHvYpba';

const DiscordIcon = FaDiscord as React.FC<{ className?: string }>;

const HomePage: React.FC = () => {
  return (
    <section className="page-section home-section">
      <div className="home-container">
        <h1 className="home-title">Under Construction</h1>

        <div className="construction-icon">
          <span className="icon-symbol">⚠</span>
        </div>

        <p className="home-description">
          Our mystical realm is currently being crafted and enchanted.
          Great things are brewing in the shadows...
        </p>

        <p className="home-subtext">
          Explore what's coming or support our dark arts
        </p>

        <div className="home-links">
          <Link to="/consoles" className="home-link-small">
            Consoles
          </Link>
          <Link to="/games" className="home-link-small">
            Games
          </Link>
        </div>

        <Link to="/donate" className="home-link">
          <span className="link-text">Enter the Donation Portal</span>
          <span className="link-arrow">→</span>
        </Link>

        <a
          href={DISCORD_INVITE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="discord-link"
        >
          <DiscordIcon className="discord-icon" />
          <span className="link-text">Join Discord Server</span>
        </a>
      </div>

      <CornerDecoration />
    </section>
  );
};

export default HomePage;
